import React, { useState } from 'react';
import { downloadFile, overAllRatingColor } from '../../utils/helpers';
import DataNotFound from '../common/DataNotFound';
import BarChart from './BarChart';

const OverAllGraph = ({ graphData, title, commentsData }) => {

  const exportToJson = e => {
    e.preventDefault();
    downloadFile({
      data: JSON.stringify(commentsData),
      fileName: 'OverAllComments.json',
      fileType: 'text/json',
    });
  };

  function readData() {
    let styleData = graphData;
    let getData = [];
    if (styleData) {
      getData = [...styleData];
    }
    getData = getData.filter(item => item.feedback !== null && item.feedback !== 0);
    getData.sort((a, b) => b.users - a.users);

    let finalData = [];
    const backgroundColors = [
      overAllRatingColor.color5,
      overAllRatingColor.color4,
      overAllRatingColor.color3,
      overAllRatingColor.color2,
      overAllRatingColor.color1,
    ];

    getData.map((item, index) => {
      finalData.push({ ...item, color: backgroundColors[index] });
    });
    if (finalData.length < 5) {
      const existingIds = finalData.map(item => item.feedback);
      const allIds = [1, 2, 3, 4, 5];
      allIds.forEach(feedback => {
        if (!existingIds.includes(feedback)) {
          finalData.push({ rating: feedback, users: 0 });
        }
      });
    }
    finalData.sort((a, b) => b.feedback - a.feedback);
    return finalData;
  }

  function renderGraph() {
    let finalData = readData();
    const idsArray = finalData.map(item => item.feedback);
    const countsArray = finalData.map(item => item.users);
    const colorsBg = finalData.map(item => item.color);
    const data = {
      labels: idsArray,
      datasets: [
        {
          data: countsArray,
          backgroundColor: colorsBg,
          borderWidth: 1,
          barThickness: 30,
          borderRadius: 10,
          borderColor: 'white',
          borderWidth: 5,
          tension: 0.3,
          padding: {
            x: 20,
            y: 15,
          },
          borderSkipped: false,
        },
      ],
    };
    if (countsArray.every(item => item === 0)) {
      return <DataNotFound />;
    }
    return (
      <BarChart
        data={data}
        showLabel={true}
        value={countsArray}
        hideBorder={false}
        indexAxis={'y'}
      />
    );
  }

  const showDownloadButton = !readData()?.every(item => item.users === 0);

  return (
    <div className="h-[50%] p-[24px] border-b">
      <div className='w-full flex justify-between'>
        <h2 className='text-[20px] font-helveticaDisp-Medium text_cus_primary leading-[48px] tracking-[-0.02em] font-[700]'>Over All Rating</h2>
        {showDownloadButton && (
          <a
            onClick={exportToJson}
            href="#checkParameter"
            className=" text-blue-primary font-bold  cursor-pointer"
          >
            Download comment JSON
          </a>
        )}
      </div>
      <div className="flex items-center justify-center">{renderGraph()}</div>

    </div >
  );
};

export default OverAllGraph;
